import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text, coreTheme } from "@kolmeo/ui-core";
const { palette } = coreTheme;
const FieldLabel = ({ rightElement, children, isRequired }) => {
    return (_jsxs(Box, { flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingY: 2, children: [_jsxs(Text, { color: palette.textPrimary, variant: "textHeavy14", children: [children, isRequired && _jsx(Text, { children: "*" })] }), rightElement && _jsx(Box, { children: rightElement })] }));
};
export default FieldLabel;
